export default class ProposalPriceBeforeAdjustmentCalculationError extends Error {
    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, ProposalPriceBeforeAdjustmentCalculationError.prototype);
    }
}
